export function relativeTime(iso: string, now = Date.now()): string {
  const then = new Date(iso).getTime()
  if (!Number.isFinite(then)) return iso
  const seconds = Math.round((now - then) / 1_000)
  if (seconds < 60) return 'just now'
  const minutes = Math.round(seconds / 60)
  if (minutes < 60) return `${minutes}m ago`
  const hours = Math.round(minutes / 60)
  if (hours < 24) return `${hours}h ago`
  const days = Math.round(hours / 24)
  if (days < 14) return `${days}d ago`
  return new Date(iso).toLocaleDateString()
}

export function formatBytes(bytes: number): string {
  if (bytes < 1_024) return `${bytes} B`
  const units = ['KB', 'MB', 'GB', 'TB']
  let value = bytes
  let unit = 'B'
  for (const next of units) {
    if (value < 1_024) break
    value /= 1_024
    unit = next
  }
  return `${value >= 100 ? Math.round(value) : value.toFixed(1)} ${unit}`
}

export function shortSha(sha: string): string {
  return sha.slice(0, 7)
}

export const originLabel: Record<string, string> = {
  mcp: 'MCP',
  cli: 'CLI',
  dashboard: 'Dashboard',
  'github-pr': 'GitHub PR',
  'manual-remote': 'Manual remote'
}

export const targetLabel: Record<string, string> = {
  'local-web-lab': 'Local Web Lab',
  'pr-web-lab': 'PR Web Lab',
  'local-electron': 'Local Electron'
}

export function formatTime(iso: string): string {
  const date = new Date(iso)
  return Number.isFinite(date.getTime())
    ? date.toLocaleString(undefined, {
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      })
    : iso
}
